<template>
  <OrderCard
    :title="t('order.cardTitles.payment')"
    class="gap-6 sm:grid-cols-1"
  >
    <template #top-right>
      <Dialog>
        <DialogTrigger as-child>
          <Button variant="ghost" size="icon" class="hover:text-primary">
            <Info class="size-5" />
          </Button>
        </DialogTrigger>
        <DialogContent class="max-w-md">
          <DialogHeader>
            <DialogTitle>{{ t("order.info.paymentInfo") }}</DialogTitle>
          </DialogHeader>
          <div class="text-sm text-muted-foreground space-y-2">
            <p>{{ t("order.info.cashOnly") }}</p>
            <p>{{ t("order.info.morePaymentsSoon") }}</p>
          </div>
        </DialogContent>
      </Dialog>
    </template>
    <FormField v-slot="{ componentField }" type="radio" name="payment.method">
      <FormItem class="space-y-3">
        <FormControl>
          <RadioGroup v-bind="componentField" class="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <FormItem>
              <FormControl class="peer sr-only">
                <RadioGroupItem
                  :value="PaymentMethod.BLIK"
                  class="peer sr-only"
                />
              </FormControl>
              <FormLabel
                class="flex sm:flex-col flex-row items-center gap-3 sm:gap-0 sm:justify-between rounded-md border-2 border-muted bg-popover p-3 sm:p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
              >
                <img :src="blikLogo" alt="" class="sm:mb-3 h-9 sm:h-10 shrink-0 object-contain" />
                {{ t("order.formLabels.card") }}
              </FormLabel>
            </FormItem>
            <FormItem>
              <FormControl>
                <RadioGroupItem
                  :value="PaymentMethod.AUTOPAY"
                  class="peer sr-only"
                />
              </FormControl>
              <FormLabel
                class="flex sm:flex-col flex-row items-center gap-3 sm:gap-0 sm:justify-between rounded-md border-2 border-muted bg-popover p-3 sm:p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
              >
                <img :src="autopayLogo" alt="" class="sm:mb-3 h-6 shrink-0 object-contain" />
                {{ t("order.formLabels.autopay") }}
              </FormLabel>
            </FormItem>
            <FormItem>
              <FormControl>
                <RadioGroupItem
                  :value="PaymentMethod.CASH"
                  class="peer sr-only"
                />
              </FormControl>
              <FormLabel
                class="flex sm:flex-col flex-row items-center gap-3 sm:gap-0 sm:justify-between rounded-md border-2 border-muted bg-popover p-3 sm:p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
                :class="{
                  border: componentField.modelValue === PaymentMethod.CASH,
                }"
              >
                <Banknote class="sm:mb-3 h-6 w-6 shrink-0" />
                {{ t("order.formLabels.cash") }}
              </FormLabel>
            </FormItem>
          </RadioGroup>
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>
    <!-- <template v-if="paymentMethod === PaymentMethod.CARD">
        <div class="grid gap-2">
          <Label for="name">Imie i nazwisko</Label>
          <Input id="name" placeholder="" />
        </div>
        <div class="grid gap-2">
          <Label for="number">Numer Karty</Label>
          <Input id="number" placeholder="" />
        </div>
        <div class="grid grid-cols-3 gap-4 items-end">
          <div class="grid gap-2">
            <Label for="month">Data ważności</Label>
            <Select>
              <SelectTrigger id="month">
                <SelectValue placeholder="Miesiąc" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="1">Styczeń</SelectItem>
                <SelectItem value="2">Luty</SelectItem>
                <SelectItem value="3">Marzec</SelectItem>
                <SelectItem value="4">Kwiecień</SelectItem>
                <SelectItem value="5">Maj</SelectItem>
                <SelectItem value="6">Czerwiec</SelectItem>
                <SelectItem value="7">Lipiec</SelectItem>
                <SelectItem value="8">Sierpień</SelectItem>
                <SelectItem value="9">Wrzesień</SelectItem>
                <SelectItem value="10">Październik</SelectItem>
                <SelectItem value="11">Listopad</SelectItem>
                <SelectItem value="12">Grudzień</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div class="grid gap-2">
            <Select>
              <SelectTrigger id="year">
                <SelectValue placeholder="Rok" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem
                  v-for="i in 10"
                  :key="i"
                  :value="`${new Date().getFullYear() + i}`"
                >
                  {{ new Date().getFullYear() + i }}
                </SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div class="grid gap-2">
            <Label for="cvc">Kod CVC</Label>
            <Input id="cvc" placeholder="CVC" />
          </div>
        </div>
      </template> -->
  </OrderCard>
</template>
<script setup lang="ts">
import { OrderCard } from "../../card";

import { RadioGroup, RadioGroupItem } from "../../radio-group";

import { Banknote } from "lucide-vue-next";
import autopayLogo from "../../../assets/Logo-standard.svg";
import blikLogo from "../../../assets/BLIK LOGO RGB.png";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../dialog";
import { Button } from "../../button";
import { Info } from "lucide-vue-next";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../form";
import { PaymentMethod } from "@acme/api";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>
